import { AnalyticsEventAction } from './analytics-types';

export const ActivityFeedbackType = Object.freeze({
  offer: 0,
  offerOut: 1,
  fundingSearchCreated: 2,
  signOffer: 3,
  changedOffer: 4,
});

export const ActivityFeedbackTypeLabel = Object.freeze({
  [ActivityFeedbackType.offer]: 'Offer',
  [ActivityFeedbackType.offerOut]: 'Offer Out',
  [ActivityFeedbackType.fundingSearchCreated]: 'Funding Search Created',
  [ActivityFeedbackType.signOffer]: 'Sign Offer',
});

export const ActivityFeedbackOption = Object.freeze({
  awaitingDocumentation: 0,
  cancelSearch: 1,
  awaitingClientDecision: 2,
  continueWithOffer: 3,
  rejectOffer: 4,
  awaitingLegals: 5,
  documentsReceived: 6,
  removeLender: 7,
});

export const ActivityFeedbackOptionLabel = Object.freeze({
  [ActivityFeedbackOption.awaitingDocumentation]: 'Awaiting Documentation',
  [ActivityFeedbackOption.awaitingClientDecision]: 'Awaiting Client Decision',
  [ActivityFeedbackOption.awaitingLegals]: 'Awaiting Legals',
  [ActivityFeedbackOption.cancelSearch]: 'Cancel Search',
  [ActivityFeedbackOption.continueWithOffer]: 'Continue With Offer',
  [ActivityFeedbackOption.rejectOffer]: 'Decline Offer',
  [ActivityFeedbackOption.documentsReceived]: 'Documents Received',
  [ActivityFeedbackOption.removeLender]: 'Remove Lender',
});

export const ActivityFeedbackChipLabel = Object.freeze({
  [ActivityFeedbackOption.continueWithOffer]: 'Offer Accepted',
  [ActivityFeedbackOption.rejectOffer]: 'Offer Declined',
  [ActivityFeedbackOption.removeLender]: 'Remove Lender',
});

export const ActivityFeedbackMap = Object.freeze({
  [ActivityFeedbackType.fundingSearchCreated]: [
    ActivityFeedbackOption.awaitingDocumentation,
    ActivityFeedbackOption.documentsReceived,
    ActivityFeedbackOption.cancelSearch,
  ],
  [ActivityFeedbackType.offer]: [
    ActivityFeedbackOption.awaitingClientDecision,
    ActivityFeedbackOption.continueWithOffer,
    ActivityFeedbackOption.rejectOffer,
  ],
  [ActivityFeedbackType.changedOffer]: [
    ActivityFeedbackOption.awaitingClientDecision,
    ActivityFeedbackOption.continueWithOffer,
    ActivityFeedbackOption.rejectOffer,
    ActivityFeedbackOption.removeLender,
  ],
  [ActivityFeedbackType.offerOut]: [
    ActivityFeedbackOption.awaitingLegals,
    ActivityFeedbackOption.continueWithOffer,
    ActivityFeedbackOption.rejectOffer,
  ],
});

export const ActivityOptionToAction = Object.freeze({
  [ActivityFeedbackOption.awaitingDocumentation]: 'awaiting-documentation',
  [ActivityFeedbackOption.awaitingClientDecision]: 'awaiting-client-decision',
  [ActivityFeedbackOption.awaitingLegals]: 'awaiting-legals',
  [ActivityFeedbackOption.cancelSearch]: 'cancel-search',
  [ActivityFeedbackOption.continueWithOffer]: 'continue-with-offer',
  [ActivityFeedbackOption.rejectOffer]: 'reject-offer',
  [ActivityFeedbackOption.documentsReceived]: 'documents-received',
});

export const ActivityOptionToAnalyticsEvent = Object.freeze({
  [ActivityFeedbackOption.awaitingDocumentation]: AnalyticsEventAction.feedbackAwaitingDocuments,
  [ActivityFeedbackOption.awaitingClientDecision]: AnalyticsEventAction.feedbackAwaitingClient,
  [ActivityFeedbackOption.continueWithOffer]: AnalyticsEventAction.feedbackContinueWithOffer,
  [ActivityFeedbackOption.rejectOffer]: AnalyticsEventAction.feedbackDeclineOffer,
  [ActivityFeedbackOption.documentsReceived]: AnalyticsEventAction.feedbackDocumentsReceived,
});

export function isValid(type) {
  return Object.values(ActivityFeedbackType).find((elem) => elem === type);
}

export function toLabel(type) {
  return ActivityFeedbackTypeLabel[type];
}
